import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { SessionService } from 'src/app/shared/services/session.service';
import { LeagueIterationService } from 'src/app/simulator-booking/services/league-iteration.service';
import { League } from 'src/app/simulator-booking/models/league';
import { provideNativeDateAdapter } from '@angular/material/core';

@Component({
    selector: 'create-league-iteration-modal',
    templateUrl: './create-league-iteration-modal.component.html',
    styleUrl: './create-league-iteration-modal.component.scss',
    providers: [provideNativeDateAdapter()],
    standalone: false
})
export class CreateLeagueIterationModalComponent extends BaseModalComponent implements OnInit {

    public league: League;
    public form = new FormGroup({
        year: new FormControl(new Date().getFullYear(), {
            validators: Validators.required
        }),
        startDateOnly: new FormControl('', {
            validators: Validators.required
        }),
        endDateOnly: new FormControl('', {
            validators: Validators.required
        }),
        startTimeOnly: new FormControl('', {
            validators: Validators.required
        }),
        endTimeOnly: new FormControl('', {
            validators: Validators.required
        }),
        entryFee: new FormControl(0, {
            validators: [Validators.required, Validators.min(0)]
        }),
        notes: new FormControl(''),
        stripePaymentLink: new FormControl('')
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: League,
        private sessionService: SessionService,
        private leagueIterationService: LeagueIterationService,
        public dialogRef: MatDialogRef<CreateLeagueIterationModalComponent>
    ) {
        super();
        this.league = data;
    }

    ngOnInit(): void {

    }

    submit({ value, valid }): void {
        if (valid) {
            this.isLoading = true;
            const startDate = new Date(value.startDateOnly);
            const endDate = new Date(value.endDateOnly);
            
            const formData = {
                ...value,

                startDateOnly: `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${String(startDate.getDate()).padStart(2, '0')}`,
                endDateOnly: `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${String(endDate.getDate()).padStart(2, '0')}`,
                startTimeOnly: this.formatTimeOnly(value.startTimeOnly),
                endTimeOnly: this.formatTimeOnly(value.endTimeOnly),
                leagueId: this.league.id,
                organizationId: this.sessionService.getUser().organizationId,
                createdBy: this.sessionService.getUserId(),
                timeZone: this.sessionService.getUser().timeZone
            };

            this.leagueIterationService.create(formData).subscribe({
                next: (result) => {
                    if (result !== null && result !== undefined) {
                        this.dialogRef.close("save");
                    }
                },
                error: (error) => {
                    console.error('Error creating iteration:', error);
                    this.setError(error, this.form);
                    this.isLoading = false;
                },
                complete: () => this.isLoading = false
            });
        }
    }


    private formatTimeOnly(value: any): string {
        // Accept Date, time string (HH:mm or HH:mm:ss), or ISO/string parseable by Date
        if (value instanceof Date) {
          const hh = String(value.getHours()).padStart(2, '0');
          const mm = String(value.getMinutes()).padStart(2, '0');
          const ss = String(value.getSeconds()).padStart(2, '0');
          return `${hh}:${mm}:${ss}`;
        }
    
        if (typeof value === 'string') {
          const timeMatch = value.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
          if (timeMatch) {
            const hh = String(Math.min(23, parseInt(timeMatch[1], 10))).padStart(2, '0');
            const mm = String(Math.min(59, parseInt(timeMatch[2], 10))).padStart(2, '0');
            const ss = String(Math.min(59, timeMatch[3] ? parseInt(timeMatch[3], 10) : 0)).padStart(2, '0');
            return `${hh}:${mm}:${ss}`;
          }
          const asDate = new Date(value);
          if (!isNaN(asDate.getTime())) {
            const hh = String(asDate.getHours()).padStart(2, '0');
            const mm = String(asDate.getMinutes()).padStart(2, '0');
            const ss = String(asDate.getSeconds()).padStart(2, '0');
            return `${hh}:${mm}:${ss}`;
          }
        }
        
        // Unknown structure (e.g., null), default to 00:00:00
        return '00:00:00';
      }
}

